import AtButton from "./AtButton/AtButton";

const AdminControls = ({ canManageAttendance, canManageQueue, active, toggleAttendance, showQueue, waitlistCount, loading }) => {
  if (!canManageAttendance && !canManageQueue) return null;

  return (
    <>
      {canManageAttendance && (
        <AtButton
          icon={active ? "/icons/stop.svg" : "/icons/begin.svg"}
          handleClick={toggleAttendance}
          disabled={loading}
        />
      )}
      {canManageQueue && (
        <AtButton
          icon="/icons/queue.svg"
          handleClick={showQueue}
          color={active ? "var(--eestec-red)" : "var(--light-gray)"}
          notification={waitlistCount}
          disabled={loading}
        />
      )}
    </>
  );
};

export default AdminControls;
